exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row .col.s12 label {\n  display: block;\n  padding-bottom: 6px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/forms/card/card.component.scss
// module id = ../../../../../src/app/pages/dashboard/forms/card/card.component.scss
// module chunks = main